import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  Signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';

import { NavItemModel, NavModel } from '@libs/shared/models';
import { NavigationService } from '@libs/shared/services';
import { NavLinkDirective } from '@libs/shared/ui';

@Component({
  selector: 'ui-lekkerland-desktop-navigation',
  imports: [MatButtonModule, NavLinkDirective],
  templateUrl: './lekkerland-desktop-navigation.component.html',
  styleUrl: './lekkerland-desktop-navigation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LekkerlandDesktopNavigationComponent {
  private readonly navigationService: NavigationService =
    inject(NavigationService);

  public readonly mainNavigation: Signal<NavModel | undefined> = toSignal(
    this.navigationService.getMainNavigation(),
    { initialValue: undefined },
  );

  public readonly items: Signal<readonly NavItemModel[]> = computed(
    (): readonly NavItemModel[] => this.mainNavigation()?.children ?? [],
  );
}
